import type { AdminRepository } from '@/modules/ctx-admin-functions/adapter';
import NotificationService from '@/assets/js/services/NotificationService';

export class AdminService {

    private readonly adminRepository: AdminRepository;

    constructor(params: {
        adminRepository: AdminRepository,
    }) {
        this.adminRepository = params.adminRepository;
    }

    public async uploadPlanDataCSV(blob: Blob): Promise<string> {
        return await this.safeRun(this.adminRepository.uploadPlanDataCSV(blob));
    }

    public async uploadPlanBasicDataCSV(blob: Blob): Promise<string> {
        return await this.safeRun(this.adminRepository.uploadPlanBasicDataCSV(blob));
    }

    public async uploadCommissionMarketvaluesCSV(blob: Blob): Promise<string> {
        return await this.safeRun(this.adminRepository.uploadCommissionMarketvaluesCSV(blob));
    }

    public async uploadEnergyIndexPlzIwetCSV(blob: Blob): Promise<string> {
        return await this.safeRun(this.adminRepository.uploadEnergyIndexPlzIwetCSV(blob));
    }

    public async uploadEnergyIndexValueIwetCSV(blob: Blob, year: number): Promise<string> {
        return await this.safeRun(this.adminRepository.uploadEnergyIndexValueIwetCSV(blob, year));
    }

    private async safeRun(promise: Promise<string>): Promise<string> {
        try {
            return await promise;
        } catch (e: unknown) {
            await NotificationService.serviceError(e);
            throw e;
        }
    }
}
